import React from 'react';
import styled from 'styled-components';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
	faSpinner,
	faTimes,
	faChevronDown,
	faChevronRight,
	faChevronLeft,
	faAngleDown,
	faAngleRight,
	faPlus,
	faComment as commentSet,
	faSearch,
	faAsterisk,
	faFileCsv,
	faSortAlphaUpAlt,
	faSortAlphaDownAlt,
	faFilter,
	faEraser,
	faMoneyBill,
	faLock,
	faBinoculars,
	faUnlock,
	faEye,
	faThumbsDown,
	faUserClock,
	faCheckCircle,
	faTimesCircle,
	faCheck,
	faExclamationCircle,
	faEdit,
	faNotEqual,
	faEquals,
	faPencilAlt,
	faTable,
	faListUl,
	faSync
} from '@fortawesome/free-solid-svg-icons';
import {
	faCheckSquare,
	faSquare,
	faSave,
	faTrashAlt,
	faComment as commentEmpty
} from '@fortawesome/free-regular-svg-icons';
import {
	faGoogle,
	faCreativeCommonsZero
} from '@fortawesome/free-brands-svg-icons';

import { defaultTheme } from '../data/themes';

const iconMap = {
	pencil: faPencilAlt,
	equal: faEquals,
	notEqual: faNotEqual,
	emptyOn: faCreativeCommonsZero,
	emptyOff: faCreativeCommonsZero,
	solidTimesCircle: faTimesCircle,
	solidCheckCircle: faCheckCircle,
	asterix: faAsterisk,
	account: faMoneyBill,
	entityLink: faSearch,
	spinner: faSpinner,
	refresh: faSync,
	clear: faTimes,
	table: faTable,
	list: faListUl,
	google: faGoogle,
	delete: faTimes,
	dropDown: faChevronDown,
	next: faChevronRight,
	prev: faChevronLeft,
	check: faCheck,
	checked: faCheckSquare,
	checkedParent: faCheckSquare,
	partiallyChecked: faCheckSquare,
	unchecked: faSquare,
	expanded: faAngleDown,
	collapsed: faAngleRight,
	save: faSave,
	back: faChevronLeft,
	forward: faChevronRight,
	trash: faTrashAlt,
	add: faPlus,
	commentSet,
	commentEmpty,
	csv: faFileCsv,
	lock: faLock,
	sortAsc: faSortAlphaUpAlt,
	sortDesc: faSortAlphaDownAlt,
	filter: faFilter,
	eraser: faEraser,
	search: faBinoculars,
	unlock: faUnlock,
	view: faEye,
	thumbDown: faThumbsDown,
	postpone: faUserClock,
	error: faExclamationCircle,
	edit: faEdit
};


const IconWrapper = styled.span`
	display: inline-block;
	line-height: 0px;
	color: ${props => props.theme[props.name + 'IconColor'] || defaultTheme[props.name + 'IconColor']} !important;
	&.active {
		cursor: pointer;
		opacity: 0.8;
		color: ${props => props.theme.activeIconColor || defaultTheme.activeIconColor};

		&:hover {
			opacity: 1;
		}
	}

	&.negative {
		color: ${props => props.theme.negativeIconColor || defaultTheme.negativeIconColor} !important;
	}

	&.disabled {
		opacity: 0.3;
	}

	> svg {
		vertical-align: middle;
		&.fa-spin {
			animation-duration: ${props => props.spinDuration}
		}
	}
`;

export default class Icon extends React.PureComponent {
	render() {
		const icon = iconMap[this.props.name];
		let customIcon = _customRenderIconCallback && _customRenderIconCallback(this.props);
		if (!icon && !customIcon) {
			return null;
		}
		return (
			<IconWrapper
				className={'icon' + (this.props.disabled ? ' disabled' : '') + (this.props.active && !this.props.disabled ? ' active' : '') + (this.props.className ? ' ' + this.props.className : '')}
				data-name={this.props.name}
				name={this.props.name}
				spinDuration={this.props.spinDuration}
				onMouseDown={this.props.disabled ? null : this.props.onMouseDown}
				title={this.props.disabled ? null : this.props.hint}
			>
				{
					customIcon ? customIcon : (
						<FontAwesomeIcon
							icon={icon}
							spin={this.props.spin}
						/>
					)
				}
			</IconWrapper>
		);
	}
}

let _customRenderIconCallback = null;

export function registerCustomIconRenderer(renderIconCallback) {
	_customRenderIconCallback = renderIconCallback;
}

